import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";
import { TeamSetup } from "@/components/TeamSetup";
import { TeamBoard } from "@/components/TeamBoard";

export default function TeamPage() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/teams/me").then((r) => setData(r.data)); }, []);

  const run = async (kind, req) => {
    setBusy(kind);
    try {
      const { data: d } = await req();
      setData(d);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-5">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase">Mon équipe</h1>
      {!data ? (
        <Skeleton className="h-40 w-full" />
      ) : data.team ? (
        <TeamBoard team={data.team} members={data.members} weekly={data.weekly} trophies={data.trophies} photoChallenge={data.photo_challenge} onLeave={() => run("leave", () => api.post("/teams/leave"))} />
      ) : (
        <TeamSetup
          busy={busy}
          onCreate={(name) => run("create", () => api.post("/teams", { name }))}
          onJoin={(code) => run("join", () => api.post("/teams/join", { code }))}
        />
      )}
    </div>
  );
}
